import {
  trigger,
  state,
  animate,
  style,
  transition,
  keyframes
} from '@angular/animations';
import {
  Component,
  ElementRef,
  Input,
  OnInit,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { MESSAGE_DELAY } from 'src/app/shared/constants/global.constants';
import { SanitizeTextService } from 'src/app/shared/services/sanitize-text.service';

@Component({
  selector: 'user-message-field',
  templateUrl: './user-message-field.component.html',
  styleUrls: ['./user-message-field.component.scss'],
  standalone: false,
  animations: [
    trigger('slideInFromRightBottom', [
      transition(':enter', [
        animate(
          `${MESSAGE_DELAY}ms ease-out`,
          keyframes([
            style({
              opacity: 0,
              transform: 'translateX(20px) rotate3d(0, 0, 1, -15deg)',
              transformOrigin: 'right bottom',
              offset: 0
            }),
            style({
              opacity: 0,
              transform: 'translateX(10px) rotate3d(0, 0, 1, -7deg)',
              transformOrigin: 'right bottom',
              offset: 0.5 // halfway: still invisible, halfway moved
            }),
            style({
              opacity: 1,
              transform: 'none',
              transformOrigin: 'right bottom',
              offset: 1
            })
          ])
        )
      ])
    ])
  ]
})
export class UserMessageFieldComponent implements OnInit {
  @Input() userMessage: { [lang: string]: string } | undefined;
  @Input() currentLang: string | undefined;
  @Input() textAlignment: 'start' | 'end' = 'start';
  @ViewChild('messageBubble') messageBubble?: ElementRef<HTMLElement>;
  sanitizedContent: SafeHtml = '';

  positionState = 'absolute';

  constructor(private sanitizeTextService: SanitizeTextService) {}

  ngOnInit(): void {
    setTimeout(() => {
      this.positionState = 'relative';
    }, 400);
    if (this.userMessage && this.currentLang) {
      this.sanitizedContent = this.sanitizeTextService.sanitizeHtml(
        this.userMessage[this.currentLang]
      );
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    // Update sanitized content when userMessage or currentLang changes
    if (changes['userMessage'] || changes['currentLang']) {
      if (this.userMessage && this.currentLang) {
        this.sanitizedContent = this.sanitizeTextService.sanitizeHtml(
          this.userMessage[this.currentLang]
        );
      }
    }
  }

  focus(): void {
    this.messageBubble?.nativeElement.focus();
  }
}
